import { InjectionToken } from '@angular/core';

import catalogJson from './onboarding-catalog.json';
import type { OnboardingCatalog } from './catalog.types';

export const ONBOARDING_CATALOG = new InjectionToken<OnboardingCatalog>('ONBOARDING_CATALOG', {
  providedIn: 'root',
  factory: () => catalogJson as OnboardingCatalog,
});
